import MatchedMap from 'utilities/src/matchedMap';

import { SiteVariantEnum } from '../../_variants';
import type { SiteSizeType } from '../../_size';

const buttonClassesMap = new MatchedMap([
  [SiteVariantEnum.Primary, 'bg-site-accent-600 text-site-neutrals-0'],
  [SiteVariantEnum.Secondary, 'border-site-accent-600 disabled:text-site-neutrals-500'],
  [SiteVariantEnum.Tertiary, 'text-site-accent-800'],
  [SiteVariantEnum.TextOnly, 'text-site-accent-800'],
]);

const buttonHoverClassesMap = new MatchedMap([
  [SiteVariantEnum.Primary, 'hover:bg-site-accent-700'],
  [SiteVariantEnum.Secondary, 'hover:bg-site-accent-600'],
  [SiteVariantEnum.Tertiary, 'hover:text-site-accent-500'],
  [SiteVariantEnum.TextOnly, 'hover:text-site-accent-400'],
]);

const buttonActiveClassesMap = new MatchedMap([
  [SiteVariantEnum.Primary, 'active:bg-site-accent-800'],
  [SiteVariantEnum.Secondary, 'active:border-site-accent-700'],
  [SiteVariantEnum.Tertiary, 'active:text-site-accent-700'],
  [SiteVariantEnum.TextOnly, 'active:text-site-accent-700'],
]);

const buttonShadowClasses = 'focus:shadow-site-accent-200';

/**
 * Site Theme / Blue Dark Button Color Variant
 */

const buttonSiteBlueDarkTheme = (_size: SiteSizeType) => ({
  buttonSiteVariantColorClasses: [buttonClassesMap, buttonHoverClassesMap, buttonActiveClassesMap],
  buttonSiteVariantColorShadowClasses: buttonShadowClasses,
});

export default buttonSiteBlueDarkTheme;
